var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center container-md px-4 py-8"},[_c('h1',{staticClass:"text-white-1",domProps:{"innerHTML":_vm._s(_vm.$t('storage_declined.title'))}}),_c('Button',{staticClass:"w-60 mt-6",attrs:{"label":_vm.$t('storage_declined.retry')},on:{"click":_vm.retry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }